import PropTypes from "prop-types";
import React from "react";
import { createGlobalStyle } from 'styled-components';
import Footer from "./footer";
import Header from "./header";
import { useSiteGlobalCss } from "./particles/hooks/useSiteGlobalCss";
import SEO from "./SEO/SEO";

const GlobalStyles = createGlobalStyle`
  ${props =>  props.settings ? props.settings : ''}
`

const Layout = ({ children, context }) => {
  const globalCss = useSiteGlobalCss()
  return (
    <>
      <GlobalStyles settings={globalCss} />
      <SEO data={context} />
      <Header />
        {children}
      <Footer /> 
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
